import React from 'react';
import { ShieldCheck, Lock, Award } from 'lucide-react';
export function Security() {
  return <section className="py-16 bg-white border-y border-stone-100" data-id="element-152">
      <div className="max-w-5xl mx-auto px-6" data-id="element-153">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-154">
          <div className="flex flex-col items-center p-6" data-id="element-155">
            <div className="w-16 h-16 rounded-full bg-[#FAF5E9] flex items-center justify-center mb-4" data-id="element-156">
              <Lock className="w-8 h-8 text-[#C5A059]" data-id="element-157" />
            </div>
            <h3 className="font-bold text-stone-900 mb-2" data-id="element-158">Pago 100% Seguro</h3>
            <p className="text-stone-500 text-sm" data-id="element-159">
              Cifrado de alta seguridad de nivel bancario.
            </p>
          </div>

          <div className="flex flex-col items-center p-6" data-id="element-160">
            <div className="w-16 h-16 rounded-full bg-[#FAF5E9] flex items-center justify-center mb-4" data-id="element-161">
              <ShieldCheck className="w-8 h-8 text-[#C5A059]" data-id="element-162" />
            </div>
            <h3 className="font-bold text-stone-900 mb-2" data-id="element-163">Privacidad Total</h3>
            <p className="text-stone-500 text-sm" data-id="element-164">
              Jamás compartiremos tu información personal.
            </p>
          </div>

          <div className="flex flex-col items-center p-6" data-id="element-165">
            <div className="w-16 h-16 rounded-full bg-[#FAF5E9] flex items-center justify-center mb-4" data-id="element-166">
              <Award className="w-8 h-8 text-[#C5A059]" data-id="element-167" />
            </div>
            <h3 className="font-bold text-stone-900 mb-2" data-id="element-168">Calidad Premium</h3>
            <p className="text-stone-500 text-sm" data-id="element-169">
              Contenido testeado y validado por miles de mujeres.
            </p>
          </div>
        </div>
      </div>
    </section>;
}